import React, { useContext, useEffect, useState } from "react";
import { courseURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import { useParams } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import LessonDetails from "../../Templates/Lessons/LessonDetails/LessonDetails";

function LessonDetailsPage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id, lesson_id } = useParams();

  const url = `${courseURL}/${id}/lessons/${lesson_id}`;
  const page = "programs";

  const [lesson, setLesson] = useState({});
  const { data, loading, error } = useFetch(url);
  // const {
  //   data: lessonsData,
  //   loading: lessonsLoading,
  //   error: lessonsError,
  // } = useFetch(`${courseURL}/${id}/lessons`);

  const [go, setGo] = useState(false);
  const { deleteRes } = useDelete(url, go, `${page}/${id}`);

  useEffect(() => {
    if (!loading && !error && data) {
      setLesson(data?.data);
    }
  }, [data, loading, error]);

  // useEffect(() => {
  //   if (!lessonsLoading && !lessonsError && lessonsData) {
  //     setLessons(lessonsData?.data);
  //   }
  // }, [lessonsData, lessonsLoading, lessonsError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "programs", data: lesson?.title });
  }, [lesson]);

  return (
    <LessonDetails
      lesson={lesson}
      setLesson={setLesson}
      url={url}
      setGo={setGo}
      loading={loading}
      courseId={id}
      // lessons={lessons}
    />
  );
}

export default LessonDetailsPage;
